import React from 'react';
import {Anchor, Button, Icon} from '@albert-io/atomic';
import withTracking from 'lib/hocs/withTracking';

import type {ButtonProps} from '@albert-io/atomic/atoms/Button/Button.react';

import GoogleContext from '../Google.context';

const TrackedAnchor = withTracking(Anchor, {
  onClick: {event: 'click', content: 'Sign into Google'}
});

const TrackedButton = withTracking(Button, {
  onClick: {event: 'click', content: 'Sign into Google'}
});

interface Props extends ButtonProps<'button'> {
  hideIcon?: boolean;
  text?: string;
  isButton?: boolean;
}

// TODO: define this type
type GoogleC = any;

const GoogleSignInButton = ({
  text = 'Sign into Google',
  isButton = false,
  hideIcon = false,
  ...btnProps
}: Props) => {
  const {handleSignIn, isRequestPending} = React.useContext<GoogleC>(GoogleContext);

  if (isButton) {
    return (
      <TrackedButton
        aria-label={text}
        disabled={isRequestPending}
        onClick={handleSignIn}
        {...btnProps}
      >
        {!hideIcon && <Icon icon={['fab', 'google']} />}
        &nbsp;{text}
      </TrackedButton>
    );
  }
  return (
    <TrackedAnchor aria-label={text} disabled={isRequestPending} onClick={handleSignIn}>
      {text}
    </TrackedAnchor>
  );
};

export default GoogleSignInButton;
